<div class="hcf-header">
  <div class="sx-logo-home-band">
    <div class="container">
      <a href="https://www.southerncross.co.nz/society" class="sx-logo-home" aria-label="Southern Cross home page"></a>
      <a href="https://www.southerncross.co.nz/society" class="hcf-text" aria-label="Southern Cross home page">
        <span><strong>Healthcare</strong> finder</span>
      </a>
      <multicolor-dropdown></multicolor-dropdown>
    </div>
  </div>
  <div class="search-input-wrapper">
    <div class="container home-text-container">
      <h1 class="home-heading">Healthcare <span>finder</span></h1>
      <h2>
        Find an Affiliated Provider or see <br />
        who offers Easy-Claim near you.
      </h2>
    </div>
    <div class="container search-input-container">
      <a routerLink="/" (click)="onHomeClick()" class="sx-logo-link" aria-label="Healthcare Finder home page">
        <span class="logo"></span>
        <span class="hcf-text"
          ><span><strong>Healthcare</strong> finder</span></span
        >
      </a>
      <hcf-autocomplete
        #keywordsAutocompleteComponent
        id="keywords-autocomplete"
        [componentId]="'keywords-autocomplete'"
        [tabIndex]="'1'"
        [autoCompleteData]="keywordAutocompleteData"
        [autocompleteSettings]="keywordAutocompleteSettings"
        (onInput)="onKeywordsInput($event)"
        (onGetData)="onKeywordsGetData()"
        (onAutocompleteItemSelected)="onAutocompleteKeywordSelected($event)"
        (onFocus)="onKeywordsInputFocus($event)"
        (onEnter)="onAutocompleteSkipped($event)">
      </hcf-autocomplete>
      <span class="divider" aria-hidden="true"></span>
      <div id="location-find-container">
        <hcf-autocomplete
          #locationAutocompleteComponent
          [ngClass]="{ hidden: usingMyLocation }"
          id="location-autocomplete"
          [componentId]="'location-autocomplete'"
          [tabIndex]="'2'"
          [autoCompleteData]="locationAutocompleteData"
          [autocompleteSettings]="locationAutocompleteSettings"
          (onInput)="onLocationInput($event)"
          (onGetData)="onLocationGetData()"
          (onAutocompleteItemSelected)="onAutocompleteLocationSelected($event)"
          (onFocus)="onLocationInputFocus($event)">
        </hcf-autocomplete>
        <div
          id="my-location-container"
          tabindex="2"
          [ngClass]="{
            hidden: !usingMyLocation,
            'looking-for-location': lookingForLocation,
            'location-found': myLocationFound,
            'failed-location': failedMyLocation,
          }"
          (click)="onMyLocationClick()">
          <span id="my-location-label">
            <span id="my-location-text">{{ myLocationLabel }}</span>
          </span>
        </div>
        <input type="submit" value="Find" class="btn-primary" id="btn-find" (click)="onFindClick()" tabindex="3" />
      </div>
    </div>
    <div id="header-svg-curve"></div>
  </div>
</div>
